export default {
	project_name: 'Academia Protecto',
	company_agency: 'Empresa / Tienda',
	add_new_company: 'Agregar nueva empresa Empresa / Tienda',
	no_company_agency_found: "Empresa / Tienda no encontrada",
	about_the: 'Acerca de',
	state: 'Dpto/Prov/Est',
	regionals: 'Pays',
	profession: 'Perfil'
}
